import React, { useEffect } from 'react'

export const VivaReportsSecureSharePage = ({ instanceData }) => {
  const redirectBaseUrl = window.VIVA_REPORTS_ORIGIN || 'https://report-service-us-east-2.purview.net'
  const title = instanceData?.title || 'Purview Reports'

  useEffect(() => {
    document.title = title
    const queryString = window.location.search
    const fullUrl = `${redirectBaseUrl}/vivareportssharedaccess.php${queryString}`

    // Simulate a 301-like redirect on the client
    window.location.replace(fullUrl)
  }, [redirectBaseUrl, title])

  // You don’t need to return anything — since the redirect happens immediately
  return null
}
